<template>
  <!-- 用户别名映射 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <el-button class="topAn" type="primary" size="mini" plain @click="add">
          <i class="el-icon-plus"></i>新增
        </el-button>
        <!-- 筛选 -->
        <div class="screening_box topAn">
          <el-select
            v-model="type_id"
            filterable
            placeholder="请选择"
            @change="selectType"
          >
            <el-option
              :label="type.name"
              :value="type.id"
              v-for="type in type_list"
              :key="type.id"
            ></el-option>
          </el-select>
          <el-input
            placeholder="请输入内容"
            v-model="input_value"
            @change="search"
            clearable
          >
          </el-input>
        </div>
      </div>
      <!-- 列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column prop="userCenterName" label="用户中心账号">
          </el-table-column>
          <el-table-column prop="localhostName" label="本地账号">
          </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
          <el-table-column align="right" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <template>
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  :hideIcon="true"
                  title="确定删除吗？"
                  @confirm="confirmDelete"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="paging_box">
        <span class="total">共{{ total }}条</span>
        <span class="perPage_num">本页{{ tableData.length }}条</span>
        <el-pagination
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="changePage"
        >
        </el-pagination>
      </div>

      <!-- 添加/编辑数量 -->
      <el-dialog
        :title="is_add ? '新增' : '编辑'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- 用户中心账号 -->
          <el-form-item label="用户中心账号" prop="userCenterName">
            <el-input
              type="text"
              v-model="ruleForm.userCenterName"
              placeholder="请输入用户中心账号"
            ></el-input>
          </el-form-item>
          <!-- 本地账号 -->
          <el-form-item label="本地账号" prop="localhostName">
            <el-input
              type="text"
              v-model="ruleForm.localhostName"
              placeholder="请输入本地账号"
            ></el-input>
          </el-form-item>
          <!-- 备注 -->
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="ruleForm.remark"
              placeholder="请输入备注(选填)"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :disabled="btn_loading"
            :loading="btn_loading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      table_height: 400,
      dialogFormVisible: false,
      is_add: true,
      // 表单
      ruleForm: {
        userCenterName: "",
        localhostName: "",
        remark: ""
      },
      // 表单检验规则
      rules: {
        userCenterName: [
          { required: true, message: "请输入用户中心账号", trigger: "blur" }
        ],
        localhostName: [
          { required: true, message: "请输入本地账号", trigger: "blur" }
        ]
      },
      row_index: 0,
      dialog_top: "15vh",
      is_init: false,
      company_list: [],
      input_value: "",
      type_id: "userCenterName",
      type_list: [
        { id: "userCenterName", name: "用户中心账号" },
        { id: "localhostName", name: "本地账号" },
        { id: "remark", name: "备注" }
      ],
      // 搜索数据
      searchForm: {
        userCenterName: "",
        localhostName: "",
        remark: ""
      },
      id: "",
      btn_loading: false
    };
  },
  computed: {
    authority() {
      return this.$route.meta.authority;
    }
  },
  watch: {
    input_value(val) {
      if (val == "") this.search();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.changeTableHeight("init");
    });

    window.onresize = () => {
      this.changeTableHeight("onresize");
    };
  },
  methods: {
    // 获取列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      this.$refs.table.bodyWrapper.scrollTop = 0;
      this.$http({
        url: this.$api.userAlias_list,
        data: {
          userCenterName: this.searchForm.userCenterName,
          localhostName: this.searchForm.localhostName,
          remark: this.searchForm.remark,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        // this.is_init = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.concent;
        }
      });
    },
    // 选择筛选类型
    selectType(e) {
      this.type_id = e;
      if (this.input_value) {
        this.page = 1;
        this.getList();
      }
    },
    // 搜索
    search() {
      this.searchForm = {
        userCenterName: "",
        localhostName: "",
        remark: ""
      };
      if (this.input_value != "")
        this.searchForm[this.type_id] = this.input_value;
      this.page = 1;
      this.getList();
    },
    // 新增/编辑
    addReq(data) {
      this.btn_loading = true;
      this.$http({
        url: this.$api.add_userAlias,
        data
      }).then(res => {
        this.btn_loading = false;
        if (res.code == 0) {
          if (this.is_add) {
            this.is_init = true;
            this.page = 1;
            this.getList();
            this.$hint("添加成功");
          } else {
            this.$set(this.tableData, this.row_index, data);
            this.$hint("保存成功");
          }
          this.cancel();
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 删除
    delReq() {
      this.$http({
        url: this.$api.del_userAlias + "/" + this.id,
        method: "get"
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(this.row_index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint(res.code + res.message, "err");
        }
      });
    },
    // 翻页
    changePage(e) {
      this.page = e;
      this.getList();
    },
    // 点击增加
    add() {
      this.dialogFormVisible = true;
      this.is_add = true;
      this.ruleForm = {
        userCenterName: "",
        localhostName: "",
        remark: ""
      };
    },
    // 编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.is_add = false;
      this.row_index = index;
      this.ruleForm = JSON.parse(JSON.stringify(row));
    },
    // 点击删除
    handleDelete(index, row) {
      this.id = row.id;
      this.row_index = index;
    },
    // 确定删除
    confirmDelete() {
      this.delReq();
    },
    // 确定新增、编辑
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let item = JSON.parse(JSON.stringify(this.ruleForm));
          this.addReq(item);
        } else {
          return false;
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    // 计算表格高度
    changeTableHeight(type) {
      let height = document.getElementById("table_list").offsetHeight;
      if (type == "onresize" && this.table_height == height) return;
      this.table_height = height;
      if (this.table_height < 550) {
        this.dialog_top = "5vh";
        this.pageSize = 10;
      } else {
        this.dialog_top = "15vh";
        this.pageSize = 20;
      }
      this.page = 1;
      this.getList();
    }
  }
};
</script>

<style></style>
<style lang="less" scoped>
/deep/ .screening_box {
  line-height: 30px;
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  .el-input__inner {
    margin: 0;
    border: none;
    border-radius: 0px;
  }
  .el-input__icon {
    line-height: 30px;
  }
  .el-select {
    .el-input__inner {
      width: 120px;
      background: #f1f1f1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/userAlias.vue